import { request } from "./request"

export interface IAIAssistantChat {
  created: string
  updated: string
  author_id: number
  name: string
  status: string
  id: string
  author_name: string
  _links: Record<string, { href: string }>
  system_hints: string[]
}

interface IAIAssistantChatMessage {
  created: string
  updated: string
  author_id: number
  message: string
  id: string
  author_name: string
  _links: Record<string, { href: string }>
}

interface IGetChatsResponse {
  _links: {
    self: { href: string }
    next: { href: string }
  }
  _embedded: {  
    ai_chats: IAIAssistantChat[]
  }
}

interface ICreateChatResponse {
  created: string
  updated: string
  author_id: number
  name: string
  status: string
  id: string
  author_name: string
  "_links": {
    self: { href: string }
    messages: { href: string }
  }
  system_hints: string[]
}

interface IGetChatMessagesResponse {
  _links: {
    self: { href: string }
    next: { href: string }
  }
  _embedded: {
    messages: IAIAssistantChatMessage[]
  }
}

interface IListingParams {
  offset?: number
  limit?: number
  total_count?: boolean
  preview?: boolean
  preview_jwt?: boolean
  is_personal?: boolean
}

export const aiApi = {
  getChats: async (userID: number, params: IListingParams, signal?: AbortSignal): Promise<IGetChatsResponse> => {
    return request('GET', `/api/2/users/${userID}/ai_chats/`, params, { signal })
  },

  createChat: async (userID: number, data: { name?: string, message?: string, attachments?: string[], system_hints?: string[] }, signal?: AbortSignal): Promise<ICreateChatResponse> => {
    return request('POST', `/api/2/users/${userID}/ai_chats/`, data, { signal })
  },

  getChatMessages: async (userID: number, chatID: string, params: IListingParams, signal?: AbortSignal): Promise<IGetChatMessagesResponse> => {
    return request('GET', `/api/2/users/${userID}/ai_chats/${chatID}/messages/`, params, { signal })
  },

  createChatMessage: async (userID: number, chatID: string, data: { message: string, attachments?: string[] }, signal?: AbortSignal): Promise<IAIAssistantChatMessage> => {
    return request('POST', `/api/2/users/${userID}/ai_chats/${chatID}/messages/`, data, { signal })
  },

  deleteChat: async (userID: number, chatID: string, signal?: AbortSignal): Promise<void> => {
    return request('DELETE', `/api/2/users/${userID}/ai_chats/${chatID}/`, {}, { signal })
  },

  updateChat: async (userID: number, chatID: string, data: { name?: string, system_hints?: string[] }, signal?: AbortSignal): Promise<void> => {
    return request('PATCH', `/api/2/users/${userID}/ai_chats/${chatID}/`, data, { signal })
  },

  getChatInfo: async (userID: number, chatID: string, signal?: AbortSignal): Promise<IAIAssistantChat> => {
    return request('GET', `/api/2/users/${userID}/ai_chats/${chatID}/`, {}, { signal })
  },
}
